import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import getHomeUrl from '../../../utilities/getHomeUrl';
import Linker from '../Link';
import { breadcrumbElement, breadCrumbIcon, heroMargins, listBreadcrumb, listBreadcrumbModeDark, listBreadcrumbModeLight } from './Breadcrumb.module.scss';
import { breadCrumbModes, testAttributes } from './Constants';

const Breadcrumb = ({ 
    breadcrumbs, 
    homeUrl = getHomeUrl(), 
    mode = breadCrumbModes.light, 
    hasHero = false,
    onHeightChange = () => null,
}) =>
{
    const breadcrumbsRef = useRef();
    const resizeObserver = useRef();

    const handleResize = () =>
    {
        if ( !breadcrumbsRef?.current ) 
        {
            onHeightChange(0)
        };
        const observedBreadcrumbsHeight = breadcrumbsRef.current?.scrollHeight || 0;
        if ( observedBreadcrumbsHeight )
        {
            onHeightChange( observedBreadcrumbsHeight );
        }
    };

    useEffect( () =>
    {
        if ( !window?.ResizeObserver ) return () => null;

        resizeObserver.current = new window.ResizeObserver(
            handleResize
        );
        resizeObserver.current.observe( document.body );

        return () => resizeObserver.current?.disconnect(); 
    }, []);

    return (
        <ul
            className={`${listBreadcrumb} ${mode === breadCrumbModes.light ? listBreadcrumbModeLight : listBreadcrumbModeDark} ${hasHero ? heroMargins : ''}`}
            data-testid={testAttributes.BREADCRUMB_CONTAINER}
            id="breadcrumb"
            itemScope
            itemType="https://schema.org/BreadcrumbList"
            ref={breadcrumbsRef}
        >
            {breadcrumbs?.map((node, index) => (
                <li
                    className={breadcrumbElement}
                    data-testid={`${testAttributes.BREADCRUMB_ELEMENT}-${index}`}
                    itemProp="itemListElement"
                    itemScope
                    itemType="https://schema.org/ListItem"
                    key={node.text}
                >
                    <Linker href={index === 0 ? homeUrl : node.url} itemProp="item">
                        <span data-testid={testAttributes.BREADCRUMB_TITLE}>
                            {index === 0 ? <span data-testid="breadcrumb-home-icon" className={breadCrumbIcon} /> : node.text}
                            <meta content={node.text} itemProp="name" />
                        </span>
                    </Linker>
                    <meta
                        content={index + 1}
                        data-testid={`${testAttributes.BREADCRUMB_POSITION}-${index}`}
                        itemProp="position"
                    />
                </li>
            ))}
        </ul>
    )
};
Breadcrumb.propTypes = {
    /** Breadcrumbs Array */
    breadcrumbs: PropTypes.arrayOf(PropTypes.object).isRequired,
    /** HomeUrl for linker 0 string */
    homeUrl: PropTypes.string,
    /** Mode for breadcrumb light or dark */
    mode: PropTypes.oneOf(Object.values(breadCrumbModes)),
    /** Extra margin for hero */
    hasHero: PropTypes.bool,
    /** Function to handle height change */
    onHeightChange: PropTypes.func,
};

export default Breadcrumb;

